module.exports = __webpack_public_path__ + "static/customer_sandbank_logo-c934bef27245f4e4d2dd27adcee6ed60.svg";